import { useTranslation } from 'react-i18next'
import React from 'react'

import Tag from '../../../../../packages/kiti/components/presentation/Tag'

const PublicTokenCallStatus = ({ status }) => {
  const { t } = useTranslation('publicToken')
  let label = t('called')
  let color = 'darkGrey'

  switch (status) {
    case 'error':
      label = t('error')
      color = 'lightRed'
      break

    case 'done':
      label = t('success')
      color = 'green'
      break

    default:
      label = t('called')
      color = 'darkGrey'
  }

  return <Tag label={label} color={color} size="small" />
}

export default PublicTokenCallStatus
